import { ref } from "vue";
import { defineStore } from "pinia";

import { Distance } from "../model/distance";
import { getDistanceByZip } from "../api/distance.api";

export const useDistanceStore = defineStore(
    "distance-store",
    () => {
        const distance = ref<Distance | null>(null);

        const fetchDistance = async (zip: string, installation?: boolean) => {
            try {
                const response = await getDistanceByZip(zip, installation);
                distance.value = response.distance;
            } catch (error) {
                distance.value = null;
                console.error("Error fetching distance:", error);
            }
        };

        return {
            fetchDistance,
            distance,
        };
    },
    { persist: true },
);
